
export const CSV_TEMPLATE_VALUES = [
    {
      name:'Default',
      value:1
    },
    {
      name:'Inforad',
      value:2
    },
    {
      name:'Pioneer Navigate',
      value:3
    },
    {
      name:'Destinator',
      value:4
    },
    {
      name:'Manual',
      value:5
    }
  ];
  
export const CSV_CONFIG_VALUES = [
    {
        name:"NO",
        value:0
    },
    {
        name:"Column 01",
        value:1
    },
    {
        name:"Column 02",
        value:2
    },
    {
        name:"Column 03",
        value:3
    },
    {
        name:"Column 04",
        value:4
    },
    {
        name:"Column 05",
        value:5
    },
    {
        name:"Column 06",
        value:6
    },
    {
        name:"Column 07",
        value:7
    },
    {
        name:"Column 08",
        value:8
    },
    {
        name:"Column 09",
        value:9
    },
    {
        name:"Column 10",
        value:10
    },
    {
        name:"Column 11",
        value:11
    },
    {
        name:"Column 12",
        value:12
    },
    {
        name:"Column 13",
        value:13
    },
    {
        name:"Column 14",
        value:14
    },
    {
        name:"Column 15",
        value:15
    },
    {
        name:"Column 16",
        value:16
    },
    {
        name:"Column 17",
        value:17
    },
    {
        name:"Column 18",
        value:18
    },
    {
        name:"Column 19",
        value:19
    }
];

export const SPLIT_WAYPOINT_OPTIONS = [
  {
    selection: 'No',
    value: 0
  },
  {
    selection: 'Tom Tom 3',
    value: 16
  },
  {
    selection: 'Tom Tom 5',
    value: 48
  },
  {
    selection: 'Tomtom Rider',
    value: 100
  },
  {
    selection: 'Manual',
    value: 16
  }
]
  
